<template>
  <span v-if="salary" class="align-middle">
    {{ salaryDisplay }}
  </span>
</template>

<script setup>
import { useMainStore } from '../store'
import { computed } from 'vue'

const props = defineProps({
  salary: {
    type: Object,
    required: true
  },
  showSalaryPeriod: {
    type: Boolean,
    default: false
  }
})

const store = useMainStore()
const salaryDisplay = computed(() => {
  if (props.salary?.min && props.salary?.max) {
    if (props.salary.min === props.salary.max) {
      return `${formatSalary(props.salary.min)} ${salaryPeriod.value}`
    }
    return `${formatSalary(props.salary.min)} - ${formatSalary(
      props.salary.max
    )} ${salaryPeriod.value}`
  } else if (props.salary?.min) {
    return `${formatSalary(props.salary.min)} ${salaryPeriod.value}`
  } else if (props.salary?.max) {
    return `${formatSalary(props.salary.max)} ${salaryPeriod.value}`
  }
  return ''
})

const salaryPeriod = computed(() => {
  if (!props.showSalaryPeriod) {
    return ''
  }
  if (props.salary?.type === 'BPU') {
    return 'per uur'
  }
  if (props.salary?.type === 'BPD') {
    return 'per dag'
  }
  if (props.salary?.type === 'BPW') {
    return 'per week'
  }
  if (props.salary?.type === 'BPM') {
    return 'per maand'
  }
  if (props.salary?.type === 'BPJ') {
    return 'per jaar'
  }
  return ''
})

const formatSalary = (salary) => {
  const locale = store.theme?.locale || 'nl'
  if (!store.theme?.notFormatCurrency) {
    return new Intl.NumberFormat(locale).format(salary)
  }
  return salary
}
</script>
